<ui-card>
    <app-segment-header title="performance.bulk-review.selectParticipantTypes"></app-segment-header>
    <ui-banner class="margin-top-3" variant="info">
        <p>{{ 'performance.participants.editInfo' | translate }}</p>
    </ui-banner>
    <form class="margin-top-3" #form="ngForm">
        <div class="flex-col">
            <mat-checkbox
                class="label-top"
                name="self"
                type="checkbox"
                [(ngModel)]="selections.self"
                (change)="onCheckboxChange($event)"
            >
                <span class="font-bold"> {{ 'performance.participants.revieweeSelf' | translate }} </span>
                <p class="text-color">{{ 'performance.participants.revieweeSelfDescription' | translate }}</p>
            </mat-checkbox>
            <mat-checkbox
                class="label-top"
                name="manager"
                type="checkbox"
                [(ngModel)]="selections.manager"
                (change)="onCheckboxChange($event)"
            >
                <span class="font-bold"> {{ 'performance.participants.revieweeManager' | translate }} </span>
                <p class="text-color">{{ 'performance.participants.revieweeManagerDescription' | translate }}</p>
            </mat-checkbox>
            <mat-checkbox
                class="label-top"
                name="directReports"
                type="checkbox"
                [(ngModel)]="selections.directReports"
                (change)="onCheckboxChange($event)"
            >
                <span class="font-bold"> {{ 'performance.participants.revieweeDirectReports' | translate }} </span>
                <p class="text-color">{{ 'performance.participants.revieweeDirectReportsDescription' | translate }}</p>
            </mat-checkbox>
            <mat-checkbox
                class="label-top"
                name="peers"
                type="checkbox"
                [(ngModel)]="selections.peers"
                (change)="onCheckboxChange($event)"
            >
                <span class="font-bold"> {{ 'performance.participants.revieweePeers' | translate }} </span>
                <p class="text-color">{{ 'performance.participants.revieweePeersDescription' | translate }}</p>
            </mat-checkbox>
        </div>
    </form>
</ui-card>
<app-review-participants-table
    [reviewees]="reviewees"
    (editparticipantName)="getParticipantName($event)"
    (participantList)="updateParticipantList($event)"
    (appSimpleTableRows)="updateParticipantTableList($event)"
    title="performance.participants.editParticipants"
    [showInlineButton]="true"
    [selections]="selections"
></app-review-participants-table>
